export function FileReadDirective() {
  return {
    scope: {
      fileread: '=',
    },
    link: function (scope, element, attrs) {
      element.bind('change', function (changeEvent) {
        scope.$apply(function () {
          scope.fileread = changeEvent.target.files[0]
        })
      })
      scope.$watch(
        () => scope.fileread,
        function (file) {
          if (!file) {
            element.val(file)
          }
        }
      )
    },
  }
}
